const minIndent = code => {
  const match = code.match(/^[ \t]*(?=\S)/gm);
  if (!match) return 0;
  return Math.min(...match.map(x => x.length));
};

const emptyLineRegex = /^\s*/;

const removeWhitespaceEdges = code => {
  const lines = code.split('\n');

  if (lines.length <= 1) {
    return code;
  }

  const firstLine = lines[0];
  const lastLine = lines[lines.length - 1];

  if (emptyLineRegex.test(firstLine)) {
    lines.shift();
  }

  if (emptyLineRegex.test(lastLine)) {
    lines.pop();
  }

  return lines.join('\n');
};

export const stripIndent = code => {
  const indent = minIndent(code);
  if (indent === 0) return code;
  const indentReg = new RegExp("^[ \\t]{".concat(indent, "}"), 'gm');
  let newCode = code.replace(indentReg, '');
  newCode = removeWhitespaceEdges(newCode);
  return newCode;
};